export const firebase =  {
  apiKey: "AIzaSyDPoC9tZoTTVo-SdBnGr9W6vDZ_KfNCBp0",
  authDomain: "office-work-timer.firebaseapp.com",
  databaseURL: "https://office-work-timer.firebaseio.com",
  projectId: "office-work-timer",
  storageBucket: "office-work-timer.appspot.com",
  messagingSenderId: "775698839882"
};

export default { firebase };



// WEBPACK FOOTER //
// ./src/config.js